module.exports = __webpack_public_path__ + "img/credential10.59e99942.png";